import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UploadDocumentsService {

  constructor(private http:HttpClient) { }

  public uploadDocument(payload): Observable<any>{
	// let headers = new HttpHeaders();
    // headers = headers.append('Content-Type', 'multipart/form-data');
    // let httpOptions = { headers: headers };
    // return this.http.post(environment.BASE_URL_DES+`desfAdmin/upload/${appId}/${fileName}`,payload,{headers: headers})
    return this.http.post(environment.BASE_URL_COMMON+'attachment/uploadDocument',payload)
  }

  public uploadVerficationDocument(appId,fileName,payload): Observable<any>{
	let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'multipart/form-data');
    let httpOptions = { headers: headers };
    return this.http.post(environment.BASE_URL_DES+`desfAdmin/upload/${appId}/${fileName}`,payload,{headers: headers})
    //return this.http.post(environment.BASE_URL_COMMON+'attachment/uploadDocument',payload)
  }

  public deleteDocument(payload): Observable<any>{
    return this.http.post(environment.BASE_URL_COMMON+'attachment/deleteByDocumentId',payload)
  }

  public getAttachmentByDocumentId(payload){
    return this.http.post(environment.BASE_URL_COMMON+'attachment/getAttachmentByDocumentId',payload)
  }

  public getDocumentList(payload): Observable<any>{
    return this.http.post(environment.BASE_URL_COMMON+'attachment/getDocumentByAppIdAndAcronym',payload)
  }

  public getlistFiles(appId): Observable<any>{
    return this.http.get(environment.BASE_URL_DES+'desfAdmin/listFiles/'+appId)
  }

  public getAttachmentDesfAdmin(appId,fileName): Observable<any>{
    return this.http.get(environment.BASE_URL_DES+`desfAdmin/downloadFile/${appId}/${fileName}`)
  }

  public uploaddesfAdmin(appId,fileName,payload){
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'multipart/form-data');
    let httpOptions = { headers: headers };
    return this.http.post(environment.BASE_URL_DES+`desfAdmin/upload/${appId}/${fileName}`,payload,{headers: headers})
  }



  //  public uploadDocument(payload): Observable<any>{
  //   return this.http.post(environment.BASE_URL_COMMON+'attachment/uploadDocument',payload)
  // }
}
